import script from "./AuthorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorPage.vue?vue&type=script&setup=true&lang=js"

import "./AuthorPage.vue?vue&type=style&index=0&id=51f5aa84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f5aa84"]])

export default __exports__